// Copyright 2021 Rennie Glen Software LLC
import { convert, Units } from "./Units";
export interface PaperSize {
    name: string;
    width: number;
    height: number;
    timestamp?: string;
}

export function convertPaperSizeUnits(paperSize: PaperSize,
    oldUnits: Units, newUnits: Units): void
{
    paperSize.height = convert(paperSize.height, oldUnits, newUnits);
    paperSize.width = convert(paperSize.width, oldUnits, newUnits);
}

export const EPOCH = "1970-01-01T00:00:00.000Z";

export function builtInPaperSizes(units: Units): PaperSize[] {
    const inchSizes: PaperSize[] = [
        { name: "Letter", width: 8.5, height: 11 },
        { name: "Legal", width: 8.5, height: 14},
        { name: "Junior Legal", width: 8.5, height: 5},
        { name: "Tabloid", width: 11, height: 17},
    ];
    const mmSizes: PaperSize[] = [
        { name: "A2", width: 420, height: 594 },
        { name: "A3", width: 297, height: 420},
        { name: "A4", width: 210, height: 297},
        { name: "A5", width: 148, height: 210},
    ];
    return inchSizes.map(size => {
        return {
            name: size.name,
            width: convert(size.width, Units.INCHES, units),
            height: convert(size.height, Units.INCHES, units),
            timestamp: EPOCH
        };
    }).concat(mmSizes.map(size => {
        return {
            name: size.name,
            width: convert(size.width, Units.MMS, units),
            height: convert(size.height, Units.MMS, units),
            timestamp: EPOCH
        };
    }));
}

/// Adds missing built in paper sizes to the list.    
export function restoreBuiltInPaperSizes(sizes: PaperSize[], units: Units): void {
    const builtInSizes = builtInPaperSizes(units);

    // First, remove the built in sizes from the list.
    const builtInNames = new Set<string>(builtInSizes.map(size => size.name));
    for (let i = sizes.length - 1; i >= 0; --i) {
        if (builtInNames.has(sizes[i].name)) {
            sizes.splice(i, 1);
        }
    }

    // Now insert the built-in sizes.
    sizes.splice(0, 0, ...builtInSizes);
}
